import { Close } from '@mui/icons-material';
import { Box, IconButton, type SxProps, type Theme, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

type Props = {
  title: ReactNode;
  onClose: () => void;
  sx?: SxProps<Theme>;
};

export const SlabDrawerHeader: FC<Props> = ({ title, onClose, sx }) => {
  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' sx={{ mb: 2, ...sx }}>
      {typeof title === 'string' ? (
        <Typography variant='h1' fontSize='2rem'>
          {title}
        </Typography>
      ) : (
        title
      )}
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  );
};
